import { render, staticRenderFns } from "./AddGallery.vue?vue&type=template&id=231153d7&scoped=true"
import script from "./AddGallery.vue?vue&type=script&lang=js"
export * from "./AddGallery.vue?vue&type=script&lang=js"
import style0 from "./AddGallery.vue?vue&type=style&index=0&id=231153d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231153d7",
  null
  
)

export default component.exports